export type GroupCheckboxState = 'checked' | 'unchecked' | 'indeterminate';

export const getGroupState = (
  itemIds: string[],
  selectedIds: Set<string>,
): GroupCheckboxState => {
  if (itemIds.length === 0) return 'unchecked';

  const selectedCount = itemIds.filter((id) => selectedIds.has(id)).length;

  if (selectedCount === 0) return 'unchecked';
  if (selectedCount === itemIds.length) return 'checked';
  return 'indeterminate';
};
